import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from "framer-motion";
import { DEFAULT_MOTION_PROPS, slideInAndScaleFromBottomMotion, } from "../../constants/motions.constants.js";
const Motion = ({ children, className, variants = slideInAndScaleFromBottomMotion, ...motionProps }) => {
    return (_jsx(motion.div, { ...DEFAULT_MOTION_PROPS, ...motionProps, className: className, variants: variants, children: children }));
};
export default Motion;
//# sourceMappingURL=Motion.js.map